
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "4 leviers de communication pour se démarquer de la concurrence",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Explorez les quatre leviers de communication efficaces pour accroître la visibilité de votre entreprise, engager votre audience et favoriser une croissance durable.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "4 leviers de communication pour se démarquer de la concurrence",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez 4 puissants leviers de communication pour gagner en visibilité et assurer votre croissance.",
        },
      ],
    };
  },
};
